<template>
  <el-col :span="24">
    <el-menu :default-active="$route.path" class="el-menu-vertical-demo" background-color="#545c64" text-color="#fff"
      active-text-color="#2589FF" router>
      <div style="height:55px;width: 100%;margin-top: 20px;text-align: left; padding-left: 20px;">
        <img src="../static/images/logo.png" alt="" style="width:55px;height: 55px;">
      </div>
      <div v-for="(item, index) in menu" :key="String(index)">
        <el-menu-item v-if="item.menuType === 1" :index="item.url">
          <i :class="item.icon"></i>
          <span slot="title">{{ item.menuName }}</span>
        </el-menu-item>
        <el-submenu v-if="item.menuType === 0" :index="String(index)">
          <template slot="title">
            <i :class="item.icon"></i>
            <span>{{ item.menuName }}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item v-for="(itemc, index) in item.child" :key="index" :index="itemc.url">{{ itemc.menuName
            }}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </div>
    </el-menu>

  </el-col>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  computed: {
    menu() {
      return this.$store.state.menu
    }
  },
  methods: {

  },
  mounted() {
  },
};
</script>
<style lang="scss" scoped>
.el-col {
  height: 100vh;

  .el-menu {
    height: 100vh;
    overflow: hidden;
  }
}

.el-menu-item {
  text-align: left;
}

.el-submenu {
  text-align: left;
}
</style>